import { render, staticRenderFns } from "./GenotypeExport.vue?vue&type=template&id=5016c4c4&"
import script from "./GenotypeExport.vue?vue&type=script&lang=js&"
export * from "./GenotypeExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports